module.exports = __webpack_public_path__ + "static/media/WelcomeWeekStyleGuide.e55d232d.jpg";